import React from 'react';
import { useTranslation } from 'react-i18next';
import Flex from 'ui/Flex/Flex';
import { Typography } from '@mui/material';
import { Navigate, useParams } from 'react-router-dom';
import ModuleWithCallToAction from './ModuleAccess/CallToActions/ModuleWithCallToAction';
import routes from './App/components/routes';

const PublicDashboardNotAccessiblePage: React.FC<object> = () => {
    const { t } = useTranslation();
    return (
        <Flex
            direction="column"
            align="center"
            justify="center"
            sx={{ backgroundColor: '#EBF6FE' }}
        >
            <Typography variant="h4" sx={{ mb: '0.75rem' }}>
                {t('publicDashBoard.unaccessibleDashBoardTitle')}
            </Typography>
            <Typography variant="subtitle1">
                {t('publicDashBoard.unaccessibleDashBoardDescription')}
            </Typography>
        </Flex>
    );
};

type Props = {
    hasDecision: boolean;
    isDecisionUser: boolean;
};

const PublicDashboardNotAccessiblePageWithRedirection = ({
    hasDecision,
    isDecisionUser,
}: Props) => {
    const { slug } = useParams();
    return (
        <ModuleWithCallToAction
            hasModule={hasDecision}
            redirectionUrl={routes.decisionCta}
        >
            {isDecisionUser ? (
                <Navigate to={`/dashboard/${slug}`} replace />
            ) : (
                <PublicDashboardNotAccessiblePage />
            )}
        </ModuleWithCallToAction>
    );
};

export default PublicDashboardNotAccessiblePageWithRedirection;
